import React, { useRef } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const Cv = () => {
  const cvRef = useRef(null);

  const downloadCV = () => {
    if (!cvRef.current) return;

    html2canvas(cvRef.current, { scale: 1.5, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.5); // Reduce quality to 50%
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let position = 0;

      if (imgHeight > 297) {
        let remainingHeight = imgHeight;
        while (remainingHeight > 0) {
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
          remainingHeight -= 297;
          position -= 297;
          if (remainingHeight > 0) pdf.addPage();
        }
      } else {
        pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
      }
      pdf.save("Ishan_Sharma_CV.pdf");
    });
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "20px", backgroundColor: "#f4f4f4" }}>
      <button
        onClick={downloadCV}
        style={{
          display: "block",
          margin: "10px auto",
          padding: "10px 15px",
          fontSize: "16px",
          backgroundColor: "#77aadd",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px",
          boxShadow: "2px 2px 5px rgba(0,0,0,0.2)"
        }}
      >
        Download CV
      </button>

      <div ref={cvRef} style={{
        maxWidth: "800px",
        margin: "auto",
        padding: "30px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        lineHeight: "1.6"
      }}>
        <header style={{
          textAlign: "center",
          paddingBottom: "15px",
          borderBottom: "3px solid #77aadd",
          marginBottom: "20px"
        }}>
          <h1 style={{ fontSize: "22px", marginBottom: "5px", color: "#003366" }}>Ishan Sharma<hr/></h1>
          <p style={{ fontSize: "14px", margin: "0", fontWeight: "bold" }}>Full Stack Developer</p>
          <p style={{ fontSize: "12px", margin: "0", color: "#555" }}>Email: <a href="mailto:your.email@example.com">ishansharma199811@gmail.com</a> | Contact: <a href="mailto:your.email@example.com">+91 8358988705</a></p>
        </header>

        <section>
        <h2 style={{ fontSize: "18px", fontStyle: "italic" }}>&#10003; About Me</h2>
          <hr />
          
          <p>Hi, I am a Full Stack Developer with 5 years of experience in developing scalable applications. Passionate about coding, problem-solving, and learning new technologies.</p>
          
        </section>
        <br/>
        <section >
          <h2 style={{ fontSize: "18px" , fontStyle: "italic" }}>&#10003;   Summary</h2>
          <hr/>
         
          <p style={{ fontFamily: 'Arial, sans-serif' }}>Full Stack Developer with skilled in Html , CSS , Java , J2.5EE , Rest-Services , Hibernate ,MyBatis, Spring MVC ,Struts , Java-Script , React js for web and rest based application .</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  5 year experience of spring framework , hibernate , Jason , Maven</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  5 year experience of developing REST based web services , Micro-service</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  5 year experience of spring MVC , spring REST, spring IOC , Spring Data , Spring DI</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  5 year experience of web layers in MVC design pattern use in spring MVC</p>


<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  5 year experience of working on web server as apache tomcat</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  5 year experience of Spring boot , spring-validation</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  2 year experience in Spring-security </p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  1 year experience in GPG encryption</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  2 year experience in Java-Script</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  1.5 year experience in react js</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  Exposure of tools like SVN , Postman , Maven , Gradel</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  3 year experience of Html , CSS , Thymleaf engine</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  3 year experience of Aws cloud , Aws Lambda , Aws Ec2 , Aws S3 Bucket , Aws Api Gate Way ,Aws Secret Manager , Aws console , Aws CLI</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  3 year of experience in Jira management and tracking system</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  3 year of experience in Automation testing with Junit , Mokito</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  1.5 year of experience in Angular</p>

<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  1 year experience of working with AI</p>
 
<p style={{ fontFamily: 'Arial, sans-serif' }}>♦  An effective communicator with honed interpersonal , analytical , problem solving and
motivational skills</p>
   </section>
   <br/>
        <section>
          <h2 style={{ fontSize: "18px" , fontStyle: "italic" }}>&#10003;   Technical Skills</h2>
          <hr />
         
          <ul>
                <li><strong>Operating System: </strong>Windows 7/10/11 , Mac OS , Linux</li>
                <li><strong>Programming Languages: </strong>Java 1.8, , Java 11 ,Java 17, J2.5EE, JavaScript</li>
                <li><strong>Java Web Technologies: </strong>Servlet, JSP, Spring, Java Web Services, REST, JDBC, Java Mail, React.js, Spring Boot , Microservice </li>
                <li><strong>Middleware:</strong> J2.5EE - JDBC, J2.5EE-Hibernate, Web Services (REST), MyBatis</li>
                <li><strong>Application/Web Server:</strong> Apache Tomcat 7/8/9, AWS, Google</li>
                <li><strong>RDBMS: </strong>MySQL 5.2.5, PostgreSQL, Oracle</li>
                <li><strong>Tools: </strong>Eclipse, Spring Tool Suite, SQL Yog, DBeaver, pgAdmin, IntelliJ, VS Code, Postman, SQL Workbench</li>
                <li><strong>Version Control:</strong> SVN Tortoise, GitHub    <strong> </strong>Maven, Gradle</li>
                <li><strong>Build Tools: </strong>Maven, Gradle</li>
                <li><strong>Frameworks:</strong> Spring, Hibernate, MVC, MyBatis, React.js</li>
                <li><strong>Cloud: </strong>AWS, Google ,Railway  </li>
                <li><strong>Other :  </strong>Postman, SVN, Logback, Swagger , slf4j , log4j </li>
               
            </ul>
        </section>
        <br/>
        <section>
          <h2 style={{ fontSize: "18px" , fontStyle: "italic" }}>&#10003;   Education</h2>
          <hr />
          
          <p>B-Tech (C.S) 2017-2021</p>
        </section>
       <br/>
        
        <section>
        
          <h2 style={{ fontSize: "18px" , fontStyle: "italic" }}>&#10003;   Experience</h2>
          <hr />
          
          <ul>
          
                <li><strong>Software Engineer - Engineersmind (July 2023 - Dec 2024)</strong><br/>
               
                    Worked as a Software Engineer handling full-stack development using Java, Spring Boot, and React.js.
                </li>
               
                <li><strong>Software Engineer - Immersive Infotech (Oct 2022 - March 2023)</strong><br/>
                    Developed RESTful web services and backend systems for enterprise applications.
                </li>
               
                <li><strong>Java Developer L2 - NeddleInnovation (April 2022 - Oct 2022)</strong><br/>
                    Built and maintained Java-based applications and optimized backend performance.
                </li>
                
                <li><strong>Java Developer - Tenza Marketing (Jan 2021 - April 2022)</strong><br/>
                    Designed and implemented Java-based solutions, integrating databases and cloud technologies.
                </li>
             </ul>
        </section>
        <br/>

        <section>
          <h2 style={{ fontSize: "18px" , fontStyle: "italic" }}>&#10003;   Projects</h2>
          <hr />
      
          <ul>
                <li><strong>Topper Tutors</strong>
                <br/> 
                <strong>Description:</strong> Topper tutor is the Web Application which collect the information from the tutor and student , which is been forwarded to the admin registered email . On this app teacher can apply for teaching and student can join the course for their learning and student can also hire personal/Home tutor .
               </li>
                

                <li><strong>E-Commerce Tenza</strong>
                <br/>
                <strong>Description:</strong> it’s a complete ecommerce project with following functionality
           
                  </li>
               

                <li><strong>Tri-Star Insurance Group</strong>
                <br/> 
                <strong>Description:</strong> In Tri-Star all think goes under the platform , it maintains 23-25 apps which are developed in java technology , inside it there is a client , employee management system , and other different things
                  </li>
                
                <li><strong>GPS Global Payment System</strong>
                <br/> 
                <strong>Description:</strong> Banking Security System Description: In GPS , it tracks payments of different-different banks like SBI , HDFC , AXIS .
                Tracking payment file for sbi Nach , Neft and rtgs payment between different-different server .

                      </li>
               


                <li><strong>Smarsh</strong>
                <br/> 
                <strong>Description:</strong> Converting Data into Client Requirements Description: In Smarsh we have to convert given data into the required XML format given by the client
                 </li>
           

                <li><strong>GS-Cremefeed</strong>
                <br/> 
                <strong>Description:</strong> Converting Data into Client Requirements Description: In Smarsh we have to convert given data into the required XML format given by the client
                
              </li>
              

                <li><strong>Smarsh-SMTP</strong>
                <br/> 
                <strong>Description:</strong> Converting Data into Client Requirements Description: In Smarsh we have to convert given data into the required XML format given by the client
                
                 </li>
                

                <li><strong>YouAdMe</strong>
                <br/> 
                <strong>Description:</strong> It is the complete Social networking project as insta-gram
               </li>
               

                <li><strong>Health-Bus</strong>
                <br/> 
                <strong>Description:</strong> it is maintain Policies and Insurance and transfer data to other Vendors or Partners
                   </li>
                
            </ul>
        </section>
        <br/>
               <section >
          
            <h2 style={{ fontSize: "18px" ,fontStyle: "italic" }}>&#10003;  Active platform</h2>
            <hr/>
            
           <p>LinkedIn: <a href="https://www.linkedin.com/in/ishan-sharma-b55820212/" target="_blank">https://www.linkedin.com/in/ishan-sharma-b55820212/</a></p>
            <p>GitHub: <a href="https://github.com/ishan199811" target="_blank">https://github.com/ishan199811</a></p>
            <p>Websites:</p>
            <ul>
                <li><a href="https://girrajtechnology.com" target="_blank">girrajtechnology.com</a></li>
                <li><a href="https://leleproperty.com" target="_blank">leleproperty.com</a></li>
                <li><a href="https://shadivivastha.com" target="_blank">shadivivastha.com</a></li>
            </ul>
        </section>
      </div>
    </div>
  );
};

export default Cv;
